<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 营养门诊-营养认知评估
-->

<template>
  <div class="life-style-page">
    <div class="top-card">
      <div class="result-box" :style="{backgroundColor: bgColor}">
        <img class="result-icon" :src="icon" alt="">
         <div class="result-text" :style="{color: textColor}">{{ initdata.assessmentResultDescription }}</div>
      </div>
      <div class="result-desc">{{ initdata.assessmentResultDescription2 }}</div>
    </div>

    <div class="bottom-suggestion">
      <div class="suggestion-title">改善建议</div>
     
      <div class="suggestion-item" v-for="item in suggestionList" :key="item.label">
        <img :src="icon_desc" class="suggestion-item-icon" alt="">
        <div class="suggestion-item-label">{{ item }}</div>
      </div>
   
    </div>
      <!-- <div class="desc">您已完成测试，如要修改可点上一页；如果确认完成，可向医护人员获取详细报告</div> -->
        <div class="next-btn-wrapper">
          <van-button round block color="#FBB13D" native-type="button" plain @click="onClickPrev">上一页</van-button>
          <van-button round block color="#FBB13D" type="info" native-type="submit" @click="onSubmit">结束测评</van-button>
        </div>
  </div>
</template>

<script>
import icon_well from '@/assets/clinic/icon-well.png'
import icon_warn from '@/assets/clinic/icon-warn.png'
import icon_bad from '@/assets/clinic/icon-bad.png'
import icon_success from '@/assets/clinic/icon-success.png'
import icon_star from '@/assets/clinic/icon-star.png'
import { Dialog } from 'vant';

export default {
  name: 'ListStyleResult',
  props: {
    initdata: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      qsList: [{
        label: '1.是否定时定量用餐（进餐规律，无暴饮暴食）？',
        name: '',
      }, {
        label: '2.每天的主食是否粗细搭配？',
        name: '',
      },{
        label: '3.每天是否食用大于1斤的蔬菜？',
        name: '',
      },{
        label: '4.每周是否摄入深海鱼类？',
        name: '',
      },{
        label: '5.每周是否摄入豆制品（如黄豆、豆腐、豆浆等）？',
        name: '',
      },{
        label: '6.是否有饮酒习惯（偶尔聚餐的饮酒不算习惯）？',
        name: '',
      },{
        label: '7.是否有吸烟习惯或长期吸二手烟？',
        name: '',
      },{
        label: '8.是否经常吃咸辣等重口味食物（每周大于4次）？',
        name: '',
      },{
        label: '9.每日睡眠总量是否大于7小时？',
        name: '',
      },{
        label: '10.每日活动量是否大于6000步？',
        name: '',
      }],
      bgColor:"",
      textColor:"",
      type:"",
      icon:"",
      icon_desc:"",
      suggestionList:[],
      formData: {

      }
    }
  },
  created() {

  },
  mounted() {
    console.log('this.initdata', this.initdata);
    if(this.initdata?.assessmentResultAdvice){
      this.suggestionList = this.initdata.assessmentResultAdvice?.split('\r\n')
      if(this.initdata.assessmentResultScore>70){
            this.icon = icon_well
            this.type='well'
            this.icon_desc=icon_success
            this.bgColor="rgba(34,198,95,0.2)"
            this.textColor="rgba(34,198,95,1)"
          }else if(this.initdata.assessmentResultScore>50){
            this.icon = icon_warn
            this.type='warn'
            this.icon_desc=icon_success
            this.bgColor="rgba(249,115,22,0.2)"
            this.textColor="rgba(249,115,22,1)"
          }else{
            this.icon = icon_bad
            this.type='bad'
            this.icon_desc=icon_star
            this.bgColor="rgba(240,68,68,0.2)"
            this.textColor="rgba(240,68,68,1)"
          }
    }
  },
  methods: {
    onSubmit() {
      console.log("nextStep")

      Dialog({ message: '您已完成测试，如要修改可点上一页；如果确认完成，可向医护人员获取详细报告' });
      // this.$emit('next-step',{type:'listStyleResult'})
    },
    onClickPrev() {
      this.$emit('prev-step',{type:'listStyleResult'})
    }
  }
};
</script>

<style scoped>
div,
p,
ul,
li,
* {
  box-sizing: border-box;
}
.life-style-page {
  width: 100%;
  height: 100vh;
  padding: 1.33rem;
  background-color: #F6F7F8;
}
.top-card{
  width: 100%;
  height: auto;
  background: #FFFFFF;
  padding: 1.33rem;
  border-radius: 1.33rem;
  margin-bottom: 1.33rem;
}
.result-box{
  width: 100%;
  height: auto;
  padding: 1.5rem;
  border-radius:1rem;
  text-align: center;
  margin-bottom: 1.33rem;
}
.result-box .result-icon{
  width:6.67rem;
  height: 6.67rem;
  margin-bottom: 1.33rem;
  margin-top: 0.5rem;
}
.result-box .result-text{
  font-weight: 500;
  font-size: 1.67rem;
  line-height: 2.33rem;
}
.result-desc{
  font-weight: 400;
  font-size: 1.33rem;
  color: #666666;
  line-height: 1.83rem;
}

.bottom-suggestion{
  width: 100%;
  height: auto;
  padding:1.33rem;
  background: #FFFFFF;
  border-radius: 1.33rem;
}
.bottom-suggestion .suggestion-title{
  font-weight: 500;
  font-size: 1.5rem;
  color: #333333;
  line-height: 2.08rem;
  margin-bottom: 2rem;
}
.suggestion-item{
  display: flex;
  align-items: center;
  margin-bottom: 0.67rem;
  gap:0.67rem;
  font-size: 1.17rem;
}
.suggestion-item-icon{
  width: 1rem;
  height: 1rem;
}
.suggestion-item-label{
  font-size: 1.25rem;
}
 .next-btn-wrapper {
  width: 100%;
  height: 6.9rem;
  display: flex;
  gap: 1.42rem;
  background-color: #fff;
  position: fixed;
  z-index: 99;
  bottom: 0;
  left: 0;
  padding: 0.33rem 2rem;
  box-shadow: inset 0rem 0.04rem 0rem 0rem rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(10px);
}
.desc{
  font-size: 14px;
  margin-top: 20px;
  color:#333;
}
</style>
